<template>

    <v-card>
        <v-card-title>Large Report Results</v-card-title>

        <v-divider></v-divider>

        <v-card-text>

            <span class="d-block mt-4">
                The report results are very large. Displaying them within the application will consume lots of memory. 
                Would you like to download the results as a csv file instead?
            </span>

            <div class="view-action-container">
                <v-btn class="mr-9" color="#c42111" height="50" @click="$emit('handle', 'file', $props.runResult)"><v-icon class="mr-1">mdi-file</v-icon> Download CSV File</v-btn>
                <v-btn class="ml-9" color="#c42111" height="50" @click="$emit('handle', 'app', $props.runResult)"><v-icon class="mr-1">mdi-grid</v-icon> View in App</v-btn>
            </div>

        </v-card-text>
    </v-card>

</template>

<script>
export default {
    name: 'ReportResultsPrompt',
    props: ['runResult'],
    components: {
        
    },
    data: () => ({

    }),

    computed: {
    },

    methods: {        

    },

    created() {
    },

    mounted() {
    },

};
</script>

<style scoped>

    .view-action-container {
        width: 100%;
        text-align: center;
        margin-top: 2em;
        margin-bottom: 1em;
    }

    
</style>

